import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProvideAuth } from "./hooks/useAuth";
import LoginForm from "./components/LoginForm";
import SignUpForm from "./components/SignUpForm";
import AddDogForm from "./components/AddDogForm";
import EditDogForm from "./components/EditDogForm";
import PublicDogInfo from "./components/PublicDogInfo";
import QRCodeGenerator from "./components/QRCodeGenerator";
import RequireAuth from "./components/RequireAuth";
import MembersPage from "./components/MembersPage";

function App() {
    return (
        <ProvideAuth>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginForm />} />
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/signup" element={<SignUpForm />} />
                    <Route
                        path="/home"
                        element={
                            <RequireAuth>
                                <MembersPage />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/generate-qr/:dogId"
                        element={
                            <RequireAuth>
                                <QRCodeGenerator />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/add-dog"
                        element={
                            <RequireAuth>
                                <AddDogForm />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/edit-dog/:dogId"
                        element={
                            <RequireAuth>
                                <EditDogForm />
                            </RequireAuth>
                        }
                    />
                    <Route path="/dogs/:dogId" element={<PublicDogInfo />} />
                </Routes>
            </Router>
        </ProvideAuth>
    );
}

export default App;
